

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import Card from '@/components/default/Card.vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxTextBox } from 'devextreme-vue';
import { DxTreeList, DxEditing, DxRowDragging, DxColumnFixing, DxStateStoring } from 'devextreme-vue/tree-list';
import { QuotationBlock, IQuotationLine, QuotationLine, QuotationDetailedDto } from '@/data/web-api-client';
import AddArticleDialog from '@/modules/quotations/components/dialogs/AddArticleDialog.vue';
import notificationService from '@/services/notificationService';

@Component({
  components: {
    Card,
    DxTreeList,
    DxEditing,
    DxRowDragging,
    DxColumnFixing,
    DxStateStoring,
    DxPopup,
    DxTextBox,
    AddArticleDialog,
  },
})
export default class QuotationDefaultCostsCard extends Vue {
  @Prop({ required: true })
  value!: QuotationBlock;

  @Prop({ required: true })
  quotation!: QuotationDetailedDto;

  @Prop({ required: true })
  summary!: Array<{
    articleId: string;
    quantity: number;
    unitPrice: number;
  }>;

  @Prop({ required: false, default: false })
  editDisabled!: boolean;

  parentRecordId: string | null = null;
  showEditNamePopup: boolean = false;

  removeBlock() {
    this.$emit('remove');
  }
  openAddArticle(parentId: string | null) {
    this.parentRecordId = parentId;
    (this.$refs.AddArticleDialog as AddArticleDialog).show = true;
  }

  saveName() {
    this.showEditNamePopup = false;
  }

  addArticle(input: {
    article: IArticle;
    data: {
      articleId: string;
      quantity: number;
    };
  }) {
    // addArticleDialog
    const dialog = this.$refs.AddArticleDialog as AddArticleDialog;
    try {
      dialog.updating = true;

      const articleVariant = input.article.variants && input.article.variants.length > 0 ? input.article.variants[0] : undefined;
      if (!articleVariant) {
        throw Error('Variant not found');
      }
      const salesPrice = (articleVariant as IArticleVariant).salesPrices.find((o) => o.type === this.quotation.projectType);
      if (!salesPrice) {
        throw Error('Pricing not found');
      }

      this.value.lines!.push(
        new QuotationLine({
          lineId: this.getGuid(),
          parentLineId: this.parentRecordId === null ? undefined : this.parentRecordId,
          articleId: input.data.articleId,
          variant: input.article.variants && input.article.variants.length > 0 ? input.article.variants[0].name : '',
          measuringUnit: input.article.measuringUnit,
          quantity: input.data.quantity,
          price: salesPrice.price,
          originalPrice: salesPrice.price,
          cost: salesPrice.cost,
          discount: 0,
          description: `${input.article.name}: ${input.article.description}`,
          remarks: '',
          total: input.data.quantity * salesPrice.price,
          originalTotal: input.data.quantity * salesPrice.price,
          margin: input.data.quantity * (salesPrice.price - salesPrice.cost),
        })
      );

      dialog.show = false;
    } catch (err) {
      notificationService.showErrorMessage('Artikel kon niet toegevoegd worden');
    } finally {
      dialog.updating = false;
    }
  }

  getGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  rowInserting(e: any) {
    const data = e.data as IQuotationLine;
    data.lineId = this.getGuid();
    this.value.lines!.unshift(new QuotationLine(data));
    const instance = (this.$refs.treelist as any).instance;
    if (instance) {
      instance.cancelEditData();
    }

    e.cancel = true;
  }

  addRow(parentId: string | null) {
    this.parentRecordId = parentId;
    (this.$refs.treelist as any).instance!.addRow(parentId);
  }

  setTextColor(e: any) {
    // price
    if (e.rowType === 'data' && e.column && e.column.caption && e.column.caption === 'Prijs') {
      if (e.data.price < e.data.originalPrice) {
        $(e.cellElement).addClass('text-danger');
      }
      if (e.data.price > e.data.originalPrice) {
        $(e.cellElement).addClass('text-success');
      }
    }
    // margin
    if (e.rowType === 'data' && e.column && e.column.caption && e.column.caption === 'Marge') {
      if (e.data.price < e.data.cost) {
        $(e.cellElement).addClass('text-danger');
      }
      if (e.data.price > e.data.cost) {
        $(e.cellElement).addClass('text-success');
      }
    }
    // Total margin
    if (e.rowType === 'data' && e.column && e.column.caption && e.column.caption === 'Marge op totaal') {
      if (e.data.price < e.data.cost) {
        $(e.cellElement).addClass('text-danger');
      }
      if (e.data.price > e.data.cost) {
        $(e.cellElement).addClass('text-success');
      }
    }
  }

  onReorderLine(e: any) {
    const visibleRows = e.component.getVisibleRows();
    const sourceData = e.itemData;
    const targetData = visibleRows[e.toIndex].data;

    if(sourceData.lineId == targetData.parentLineId){
      // User tried to drag a parent line in one of its child lines.
      // Not allowed
      return;
    }

    if (e.dropInsideItem) {
      e.itemData.parentLineId = targetData.lineId;
      e.component.refresh();
    } else {
      const sourceIndex = this.value.lines!.indexOf(sourceData);
      let targetIndex = this.value.lines!.indexOf(targetData);

      if (sourceData.parentLineId !== targetData.parentLineId) {
        sourceData.parentLineId = targetData.parentLineId;
        if (e.toIndex > e.fromIndex) {
          targetIndex++;
        }
      }

      this.value.lines!.splice(sourceIndex, 1);
      this.value.lines!.splice(targetIndex, 0, sourceData);
    }
  }

  updateNotes(e: any) {
    const promptValue = prompt('Opmerking', e.row.data.remarks);
    if (promptValue) {
      e.row.data.remarks = promptValue;
    }
  }

  get measuringUnits() {
    const measuringUnits = this.$store.getters['measuringUnits/data'];

    return measuringUnits ?? [];
  }

  get total() {
    let res = 0;
    if (!this.value.lines || this.value.lines.length <= 0) {
      return res;
    }

    this.value.lines.forEach((line: any) => {
      if (line.quantity && line.price) {
        res += line.quantity * line.price;
      }
    });

    return res;
  }

  get totalOriginal() {
    let res = 0;
    if (!this.value.lines || this.value.lines.length <= 0) {
      return res;
    }

    this.value.lines.forEach((line: any) => {
      if (line.quantity && line.originalPrice) {
        res += line.quantity * line.originalPrice;
      }
    });

    return res;
  }

  get margin() {
    let res = 0;
    if (!this.value.lines || this.value.lines.length <= 0) {
      return res;
    }

    this.value.lines.forEach((line: any) => {
      const cost = line.cost ? line.cost : 0; // get cost

      // Calculate margin
      if (line.quantity && line.price) {
        res += line.quantity * (line.price - cost);
      }
    });

    return res;
  }

  get disabled() {
    return this.quotation.status! > 1;
  }

  get columns() {
    const self = this;
    return [
      {
        dataField: 'description',
        caption: 'Beschrijving',
      },
      {
        dataField: 'measuringUnit',
        caption: 'Meeteenh.',
        lookup: {
          dataSource: self.measuringUnits,
        },
      },
      {
        dataField: 'quantity',
        caption: 'Hoeveelheid',
        dataType: 'number',
        alignment: 'left',
        calculateCellValue(value: any) {
          if (value.quantity) {
            return Math.round(value.quantity * 1000) / 1000;
          }
          return 0;
        },
      },
      {
        dataField: 'price',
        caption: 'Prijs',
        dataType: 'number',
        alignment: 'left',
        format: CURRENCY_FORMAT,
      },
      {
        dataField: 'cost',
        caption: 'Kost',
        dataType: 'number',
        alignment: 'left',
        format: CURRENCY_FORMAT,
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Orginele prijs',
        cssClass: '',
        format: CURRENCY_FORMAT,
        calculateCellValue(value: any) {
          if (value.originalPrice) {
            return value.originalPrice;
          }
          return 0;
        },
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Marge',
        cssClass: '',
        format: CURRENCY_FORMAT,
        calculateCellValue(value: any) {
          if (value.cost && value.price != undefined) {
            return value.price - value.cost;
          }
          if (value.price) {
            return value.price;
          }
          return 0;
        },
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Marge op totaal',
        cssClass: '',
        format: CURRENCY_FORMAT,
        calculateCellValue(value: any) {
          if (value.cost && value.price != undefined && value.quantity) {
            return (value.price - value.cost) * value.quantity;
          }

          return 0;
        },
      },
      {
        alignment: 'left',
        formItem: {
          visible: false,
        },
        caption: 'Totaal',
        cssClass: '',
        format: CURRENCY_FORMAT,
        calculateCellValue(value: any) {
          if (value.quantity && value.price != undefined) {
            return value.quantity * value.price;
          }
          return 0;
        },
      },
      {
        dataField: 'remarks',
        caption: 'Opmerkingen',
        dataType: 'text',
        visible: true,
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Opmerking',
            icon: 'fas fa-comment-dots',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled && !self.editDisabled;
            },
            onClick: this.updateNotes,
          },
          {
            hint: 'Code invoegen',
            icon: 'fas fa-search-plus',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled && !self.editDisabled;
            },
            onClick: (e: any) => {
              this.openAddArticle(e.row.data.lineId);
            },
          },
          {
            hint: 'Verbergen',
            icon: 'fas fa-eye',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.hidden && !self.disabled && !self.editDisabled;
            },
            onClick: (e: any) => {
              self.value.lines!.find((line) => line.lineId === e.row.data.lineId)!.hidden = true;
              (this.$refs.treelist as any).instance.repaint();
            },
          },
          {
            hint: 'Tonen',
            icon: 'fas fa-eye-slash',
            visible(e: any) {
              return !e.row.isEditing && e.row.data.hidden && !self.disabled && !self.editDisabled;
            },
            onClick: (e: any) => {
              self.value.lines!.find((line) => line.lineId === e.row.data.lineId)!.hidden = false;
              (this.$refs.treelist as any).instance.repaint();
            },
          },
          'edit',
          'delete',
        ],
      },
    ];
  }
}
